export const improveSkins = {
    id: 'ImproveSkins',
    start: '2021-07-09',
    expiry: '2021-08-03',
    author: 'Max Duval (@mxdvl)',
    description: 'Serve Improve page skins via Prebid and measure performance',
    audience: 0,
    audienceOffset: 0.25,
    successMeasure: 'no significant impact on ad speed performance',
    audienceCriteria: 'n/a',
    showForSensitive: true,
    variants: [
        {
            id: 'variant',
            test: () => {
                // do nothing
            },
        },
    ],
    canRun: () => true,
};
